import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Dropdown,
  Form,
  FormField,
  Label,
  TextArea,
  Icon,
} from "semantic-ui-react";
import { Timestamp } from "firebase/firestore";
import { ORGAN_TIPS } from "react-lib/apps/segment/sequence/SegmentTarget";
import moment from "moment";
import CardPreviewPost from "./CardPreviewPost";

import { formatDatetime } from "react-lib/utils/dateUtils";

type ContentEditorType = {
  content?: string;
  organ: string;
  suggestionLabs: any[];
  updatedAt?: Timestamp;
  updatedBy?: { id: number; name: string };
  optionsOrgans: any[];
  optionsSuggestLab: any[];

  id: string;
  runSequence: any;
  publishedAt?: Timestamp;
  publishedVersion: number;
  idxPublishLoading: string;
  idxUnpublishLoading: string;
  idxSaveLoading: string;
  setModalParam: any;
  version: number;
  publishJson: any;
  isEdit: boolean;
};

const ContentEditorOrganTips = (props: ContentEditorType) => {
  const [isEdit, setIsEdit] = useState(false);
  const [version, setVersion] = useState<number | undefined>(0);
  const [isExpanded, setIsExpanded] = useState(false); // เพิ่ม state สำหรับ expand/collapse

  console.log('ContentEditorOrganTips props: ', props);
  useEffect(() => {
    setVersion(props.version);
  }, [props.version]);

  useEffect(() => {
    if (!props.version) setIsExpanded(true);
  }, [props.version]);

  const versionsOptions = useMemo(() => {
    let versions: any[] = [];
    console.log("versions: ", versions);
    if (props.version) {
      console.log("props.version: ", props.version);
      versions = new Array(Number(props.version)).fill(1);
      console.log("1 versions: ", versions);
      versions = versions.map((i, idx) => ({
        key: idx + 1,
        value: idx + 1,
        text: `Version ${idx + 1}`,
      }));
      console.log("2 versions: ", versions);
    }
    console.log("3 versions: ", versions);
    return versions;
  }, [props.version]);

  const getOrganName = () => {
    const organOption = props.optionsOrgans.find((option) => option.value === props.organ);
    const text: string = organOption?.text || props.organ;

    return text;
  };

  const saveAtUTC = props.publishJson?.metadata?.saved_at
    ? (props.publishJson?.metadata?.saved_at as string).endsWith("Z")
      ? props.publishJson?.metadata?.saved_at
      : props.publishJson?.metadata?.saved_at + "Z"
    : "";

  return (
    <Card fluid>
      <CardContent>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            gap: "4px",
            justifyContent: "space-between",
            marginBottom: "6px",
          }}
        >
          <div>
            {/* { props.publishedAt ? <Label size="tiny" color="orange">
              Publish (Version: {props.publishedVersion}): {moment(props.publishedAt.toDate()).format(`YYYY/MM/DD [[]HH:mm[]]`)}
          </Label> : null }  */}
            {!isExpanded && (
              <span style={{ fontSize: "1.35rem", fontWeight: "bold" }}>{getOrganName()}</span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <div>{props.id}</div>
            {/* <div><Dropdown
              selection
              value={version}
              disabled={version === undefined}
              onChange={(e, {value}) => {
                console.log(" value : ", value)
                setVersion(value as number)
                props.runSequence({
                  sequence: "SegmentTarget",
                  action: "GetPublicContents",
                  id: props.id,
                  version: value,
                  type: POST,
                })
              }}
              options={versionsOptions}
            /></div> */}

            {/* { version === props.version ? <>
              { (version !== undefined) && (version === props.publishedVersion) ? (
                <div style={{ marginBottom: "3px" }}>
                  <Label size="tiny" color="orange">
                    Publish
                  </Label>
                </div>
              ) : (
                <div style={{ marginBottom: "3px" }}>
                  <Label size="tiny" color="grey">
                    No Publish
                  </Label>
                </div>
              ) }
            </> : <>
              { saveAtUTC ? <div style={{ marginBottom: "3px" }}>
                <Label size="tiny" color="pink">
                  Had Been Published {moment(saveAtUTC).format(`YYYY/MM/DD [[]HH:mm[]]`)}
                </Label>
              </div> : null }
            </>} */}
            {props.publishedAt ? (
              <Label size="tiny" color="orange">
                Publish: {moment(props.publishedAt.toDate()).format(`YYYY/MM/DD [[]HH:mm[]]`)}
              </Label>
            ) : (
              <Label size="tiny" color="grey">
                Not publish
              </Label>
            )}
          </div>
        </div>

        {!isExpanded && (
          <Form style={{ borderBottom: "1px solid #eee", padding: "5px 0 10px" }} size="small">
            <div style={{ color: "#888", marginBottom: "5px" }}>
              {(props.content || "").length > 50
                ? `${props.content?.slice(0, 50)}...`
                : props.content}
            </div>
            <div style={{ color: "#999" }}>Edit by : {props.updatedBy?.name}</div>
            <div style={{ color: "#999" }}>
              Last edit : {formatDatetime(props.updatedAt?.toDate(), true)}
            </div>
            <div style={{ color: "#999" }}>
              Post date : {formatDatetime(props.publishedAt?.toDate(), true)}
            </div>
          </Form>
        )}

        {isExpanded && (
          <>
            {version === props.version ? (
              <Form>
                <FormField>
                  <label>
                    อวัยวะ<span style={{ color: "red" }}>*</span>
                  </label>
                  <Dropdown
                    fluid
                    selection
                    search
                    options={props.optionsOrgans}
                    clearable
                    value={props.organ}
                    onChange={(e, data) => {
                      setIsEdit(true);
                      props.runSequence({
                        sequence: "SegmentTarget",
                        action: "UpdateContents",
                        organ: data.value,
                        id: props.id,
                        type: ORGAN_TIPS,
                      });
                    }}
                  />
                </FormField>
                <FormField>
                  <label>
                    คำวินิจฉัย<span style={{ color: "red" }}>*</span>
                  </label>
                  <TextArea
                    rows={10}
                    value={props.content}
                    onChange={(e, data) => {
                      setIsEdit(true);
                      props.runSequence({
                        sequence: "SegmentTarget",
                        action: "UpdateContents",
                        content: data.value,
                        id: props.id,
                        type: ORGAN_TIPS,
                      });
                    }}
                  />
                </FormField>
                <FormField>
                  <label>คำแนะนำรายการตรวจ Lab ที่เกี่ยวข้อง</label>
                  <Dropdown
                    fluid
                    selection
                    search
                    options={props.optionsSuggestLab}
                    multiple
                    clearable
                    value={props.suggestionLabs}
                    onChange={(e, data) => {
                      setIsEdit(true);
                      props.runSequence({
                        sequence: "SegmentTarget",
                        action: "UpdateContents",
                        suggestionLabs: data.value,
                        id: props.id,
                        type: ORGAN_TIPS,
                      });
                    }}
                  />
                </FormField>
              </Form>
            ) : (
              <CardPreviewPost
                id={props.id}
                version={props.version}
                publishJson={props.publishJson}
              />
            )}
          </>
        )}
      </CardContent>

      {isExpanded && (
        <CardContent extra>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px", margin: "4px" }}>
            {props.publishedAt ? (
              <Button
                loading={props.idxUnpublishLoading === props.id}
                size="tiny"
                onClick={() => {
                  props.setModalParam({
                    open: true,
                    header: "ยืนยันการซ่อนโพสนี้",
                    content: "ยืนยันการซ่อนโพสนี้",
                    cancle: () => {
                      props.setModalParam(undefined);
                    },
                    cancleText: "ยกเลิก",
                    confirm: () => {
                      props.setModalParam(undefined);
                      props.runSequence({
                        sequence: "SegmentTarget",
                        action: "UnPublish",
                        contentId: props.id,
                        type: ORGAN_TIPS,
                      });
                    },
                    confirmText: "ยืนยัน",
                  });
                }}
              >
                ซ่อน
              </Button>
            ) : null}
            <Button
              size="tiny"
              onClick={() => {
                props.setModalParam({
                  open: true,
                  header: "ยืนยันการลบ",
                  content: "ยืนยันการลบ",
                  cancle: () => {
                    props.setModalParam(undefined);
                  },
                  cancleText: "ยกเลิก",
                  confirm: () => {
                    props.setModalParam(undefined);
                    props.runSequence({
                      sequence: "SegmentTarget",
                      action: "DeleteContent",
                      contentId: props.id,
                      type: ORGAN_TIPS,
                    });
                  },
                  confirmText: "ยืนยัน",
                });
              }}
            >
              ลบโพสต์
            </Button>
            <Button
              size="tiny"
              loading={props.idxSaveLoading === props.id}
              disabled={!isEdit || (version !== undefined && props.publishedVersion >= version)}
              onClick={() => {
                props.runSequence({
                  sequence: "SegmentTarget",
                  action: "SaveContent",
                  id: props.id,
                  content: props.content,
                  organ: props.organ,
                  suggestionLabs: props.suggestionLabs,
                  type: ORGAN_TIPS,
                });
                setIsEdit(false);
              }}
            >
              บันทึกร่าง
            </Button>
            <Button
              size="tiny"
              disabled={!props.isEdit}
              loading={props.idxPublishLoading === props.id}
              onClick={() => {
                props.setModalParam({
                  open: true,
                  header: "ยืนยันการโพสต์",
                  content: "ยืนยันการโพสต์",
                  cancle: () => {
                    props.setModalParam(undefined);
                  },
                  cancleText: "ยกเลิก",
                  confirm: () => {
                    props.setModalParam(undefined);
                    props.runSequence({
                      sequence: "SegmentTarget",
                      action: "Publish",
                      contentId: props.id,
                      publishedVersion: props.version,
                      type: ORGAN_TIPS,
                    });
                  },
                  confirmText: "ยืนยัน",
                });
              }}
            >
              โพสต์
            </Button>
          </div>
        </CardContent>
      )}

      {!!props.version && (
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "0px 0px 8px" }}>
          <Button
            style={{
              background: "transparent",
              border: "none",
              color: "var(--primary-theme-color)",
              padding: "0px 9px 7px 12px",
            }}
            size="small"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "View less" : "View more"}
            <Icon style={{ marginLeft: "5px" }} name={isExpanded ? "angle up" : "angle down"} />
          </Button>
        </div>
      )}
    </Card>
  );
};

export default ContentEditorOrganTips;
